module.exports = __webpack_public_path__ + "resources/img/chk.b5dfb9700e9170bd921b5dee27ee347d.png";